const RECORDER_IMAGES = [
  'tape-recorder-BG.png',
  'tape-recorder-buttons-inactive.png',
  'rewindplay-pressed.png',
  'play-pressed.png',
  'rec-pressed.png',
  'LED-on.png',
  'rewind-pressed.png',
];

const CLICK_SOUND_FILES = ['15757_1460486786.mp3', '16971_1461335345.mp3'];

/** Motor / mech bed for auto-rewind (plays with Web Audio reverse scrub). */
export const VOICE_NOTE_AUTO_REWIND_FILE = 'auto-rewind.mp3';

/** Still frame for `<video poster>` + overlay until mobile decodes first frame (Safari often shows nothing until play). */
export const TAPE_DECK_THUMB_FILE = 'tape-deck-thumb.jpg';

/** @param {string} filename */
export function recorderPublicUrl(filename) {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const prefix = base && base !== '.' ? base : '';
  return `${prefix}/assets/recorder/${filename}`;
}

export function tapeDeckVideoPublicUrl() {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const prefix = base && base !== '.' ? base : '';
  return `${prefix}/pics/recorder/tape-deck.mov`;
}

export function tapeDeckThumbPublicUrl() {
  return recorderPublicUrl(TAPE_DECK_THUMB_FILE);
}

/** Depress / “down” click SFX (public path under assets/recorder). */
export const VOICE_NOTE_CLICK_DEPRESS_FILE = CLICK_SOUND_FILES[0];
/** Release / “up” click SFX. */
export const VOICE_NOTE_CLICK_RELEASE_FILE = CLICK_SOUND_FILES[1];

/** @param {string} url */
function preloadImage(url) {
  return new Promise((resolve, reject) => {
    const i = new Image();
    i.onload = () => resolve();
    i.onerror = () => reject(new Error(`image ${url}`));
    i.src = url;
  });
}

/** @param {string} url */
function preloadMediaElement(url) {
  return new Promise((resolve, reject) => {
    const a = new Audio();
    const ok = () => {
      a.removeEventListener('canplay', ok);
      a.removeEventListener('error', bad);
      resolve();
    };
    const bad = () => {
      a.removeEventListener('canplay', ok);
      a.removeEventListener('error', bad);
      reject(new Error(`audio ${url}`));
    };
    a.addEventListener('canplay', ok, { once: true });
    a.addEventListener('error', bad, { once: true });
    a.preload = 'auto';
    a.src = url;
    a.load();
  });
}

/** @param {string} url */
function preloadVideo(url) {
  return new Promise((resolve, reject) => {
    const v = document.createElement('video');
    const ok = () => {
      v.removeEventListener('loadeddata', ok);
      v.removeEventListener('error', bad);
      resolve();
    };
    const bad = () => {
      v.removeEventListener('loadeddata', ok);
      v.removeEventListener('error', bad);
      reject(new Error(`video ${url}`));
    };
    v.addEventListener('loadeddata', ok);
    v.addEventListener('error', bad);
    v.preload = 'auto';
    v.muted = true;
    v.playsInline = true;
    v.src = url;
    v.load();
  });
}

/** Wait for PNGs, tape poster JPG, tape video, and recorder click MP3s so the deck can show without pop-in. */
export function preloadVoiceNoteDeckAssets() {
  const images = RECORDER_IMAGES.map((f) => preloadImage(recorderPublicUrl(f)));
  const thumb = preloadImage(tapeDeckThumbPublicUrl()).catch(() => {
    /* Missing file: TapeDeckVideo drops poster overlay on img error */
  });
  const clicks = CLICK_SOUND_FILES.map((f) => preloadMediaElement(recorderPublicUrl(f)));
  const autoRewind = preloadMediaElement(recorderPublicUrl(VOICE_NOTE_AUTO_REWIND_FILE)).catch(() => {});
  const video = preloadVideo(tapeDeckVideoPublicUrl());
  return Promise.all([...images, thumb, ...clicks, autoRewind, video]);
}
